import { CanalChaveApiCodec } from "./CanalChaveApiCodec";

export type CanalChaveApiWhatsapp = {
    phoneNumberId: string;
    phoneNumber: string;
    wabaId: string;
    businessId: string;
    pin: string;
    token: string;
    enableCalling: boolean;
    tipo: "whatsapp";
};

/**
 * Normaliza o telefone para "+<dígitos>".
 *
 * A Meta devolve `display_phone_number` ora cru ("15553167521"), ora formatado
 * ("+1 555-316-7521"), dependendo do número. As rotas de webhook resolvem o
 * canal com `like` sobre a `chave_api`, comparando com o valor cru do payload —
 * então o formato gravado precisa ser sempre o mesmo, ou o canal não é achado.
 */
const normalizarTelefone = (telefone?: string): string => {
    const digitos = String(telefone ?? "").replace(/\D/g, "");
    return digitos ? `+${digitos}` : "";
};

export class CanalChaveApiCodecWhatsapp implements CanalChaveApiCodec<CanalChaveApiWhatsapp> {
    encode(value: CanalChaveApiWhatsapp): string {
        return `${value.phoneNumberId}:${normalizarTelefone(value.phoneNumber)}:${value.wabaId}:${value.businessId}:${value.pin}:${value.token}:${Boolean(value.enableCalling)}`;
    }
    decode(value: string): CanalChaveApiWhatsapp {
        const [phoneNumberId, phoneNumber, wabaId, businessId, pin, token, enableCalling] = value.split(":");
        return {
            phoneNumberId,
            phoneNumber,
            wabaId,
            businessId,
            pin,
            token,
            enableCalling: enableCalling === "true",
            tipo: "whatsapp",
        };
    }
}
